import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {PcnBlockService} from './pcn-block.service';

/**
 * Pcn guard service, used to check, for routes if user has set pcn.
 */
@Injectable()
export class PcnGuard  {

  constructor(private router: Router,
              private pcnBlockService: PcnBlockService) {}

  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const PCN = this.pcnBlockService.getLocalPcn();
    if (PCN === null || PCN.pcn === undefined || PCN.pcn === '') {
      this.router.navigate(['/pcn-details']);
      return false;
    }
    return true;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot,
                   state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }

}
